module.exports = __webpack_public_path__ + "images/agro02-85d3bfe9f3a3344bc48c3c106465beac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/agro02.jpeg
// module id = 223
// module chunks = 0